import { render, staticRenderFns } from "./SkuItem.vue?vue&type=template&id=d1e57cc0&"
import script from "./SkuItem.vue?vue&type=script&lang=js&"
export * from "./SkuItem.vue?vue&type=script&lang=js&"
import style0 from "./SkuItem.vue?vue&type=style&index=0&id=d1e57cc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports